import * as PIXI from "pixi.js";
import Main from "../../../Main";
import HTPSecondPart from "../HTPSecondPart";
import { HTPEllipseColor } from "../../../types/Enum";
import HTPAboutFwTextAnimation from "../../../animations/HTPAboutFwTextAnimation";

export default class HTPInfoAboutFirework extends PIXI.Container {
  private Main = Main.getInstance();
  private HTPSecondPart = HTPSecondPart.getInstance();
  textColor: PIXI.Text;
  textEmblem: PIXI.Text;
  startScale = .2;
  constructor() {
    super();
    this.addCoord();
    this.addBg();
    this.addText();
    this.addToCon();


    this.scale.set(this.startScale);
  }

  addCoord() {
    const dim = this.Main.getDim();

    let _x = dim.width / 2 + 430;
    let _y = dim.height / 2;
    if (dim.width < dim.height) {
      _x = dim.width / 2;
      _y = dim.height / 2 + 450;
    }
    
    this.x = _x;
    this.y = _y;
  }

  addBg() {
    let d = [-100, -250, 200, 500]
    const dim = this.Main.getDim();
    if (dim.width < dim.height) {
      d = [-250, -80, 500, 160]
    }
    const bg = new PIXI.Graphics()
      .roundRect(d[0], d[1], d[2], d[3], 30)
      .fill(0x777dcc)
    this.addChild(bg);
  }

  private generateLine(text: string, x: number, y: number) {
    let color = 0xFFFFFF;
    const line = new PIXI.Text({ text });

    if (text == "COLOR") {
      color = HTPEllipseColor.sameColor;
      this.textColor = line;
      new HTPAboutFwTextAnimation(this.textColor, 0);
    } else if (text == "EMBLEM") {
      color = HTPEllipseColor.sameType;
      this.textEmblem = line;
      new HTPAboutFwTextAnimation(this.textEmblem, 500);
    }
    line.x = x;
    line.y = y;
    line.anchor.set(.5);
    line.style.fill = color;
    line.style.fontWeight = "800";
    this.addChild(line);
  }

  addText() {
    const dim = this.Main.getDim();
    const textArr = ["CLICK ON", "FIREWORKS", "THAT MATCH", "THE", "COLOR", "OR THE", "EMBLEM", "OF THE", "WINNING", "FIREWORK"]
    textArr.forEach((line, lineI) => {
      let _x = 0;
      let _y = -180 + 40 * lineI;

      if (dim.width < dim.height) {
        const coord = [[-170, -40], [-20, -40], [150, -40], [-170, 0], [-90, 0], [20,0 ], [130, 0], [-135, 40], [-20, 40], [115, 40]]
        _x = coord[lineI][0];
        _y = coord[lineI][1]
      }
      this.generateLine(line, _x, _y)
    })
  }
  addToCon() {
    this.HTPSecondPart.addChild(this);
  }
}